import { Flex } from '@homebotapp/hb-react-component-catalog'

type SidebarProps = {
  children: React.ReactNode
}

export const Sidebar = ({ children }: SidebarProps) => {
  return (
    <Flex
      flexDirection='column'
      as='aside'
      width='var(--left-sidebar-width)'
      bg='card-bg-layer-1'
      position='fixed'
      top={`calc(var(--top-nav-bar-height, 0px) + var(--banner-height, 0px))`}
      bottom='0'
      left='0'
      pt='8'
      pb='4'
      px='2'
      zIndex='docked'
      boxShadow='base'
      borderRightWidth='1px'
      overflowY='auto'
    >
      {children}
    </Flex>
  )
}
